import { EnsaioAnalise } from "@/contexts/laboratorio/ensaioAnalise/model/EnsaioAnalise";
import { api } from "@/shared/api/api";

export const createEnsaioAnaliseApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const listAll = async () => {
    const { data } = await api.get<EnsaioAnalise[]>("/ensaios-analise/todos", {
      headers,
    });
    return data;
  };

  return { listAll };
};
